import React from 'react';
import AppModal from './AppModal';
import CommunicationMaster from '../Admin/CommunicationMaster/communicationMaster';

/**
 * CommunicationMasterModal
 * 
 * A reusable modal that wraps the CommunicationMaster component.
 * It allows sending emails or WhatsApp messages from any part of the dashboard.
 * 
 * Props:
 * - isOpen: Boolean to control modal visibility
 * - onClose: Function to call when modal is closed
 * - defaultSelectedIds: Array of customer/group IDs to pre-select
 * - defaultChannel: 'email' or 'whatsapp'
 * - defaultTemplateId: ID of the template to pre-load
 * - title: Modal title (optional)
 * - width: Modal width (default: '1200px')
 */
const CommunicationMasterModal = ({
    isOpen,
    onClose,
    defaultSelectedIds = [],
    defaultChannel = 'email',
    defaultTemplateId = null,
    defaultTemplateName = null,
    title = 'Send Communication',
    width = '1200px',
    policyData = [],
    isDirectSelection = false,
    ...props
}) => {
    return (
        <AppModal
            isOpen={isOpen}
            onClose={onClose}
            width={width}
            title={title}
        >
            <div className="communication-modal-content" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                <CommunicationMaster
                    isModal={true}
                    defaultSelectedIds={defaultSelectedIds}
                    defaultChannel={defaultChannel}
                    defaultTemplateId={defaultTemplateId}
                    defaultTemplateName={defaultTemplateName}
                    hideTemplate={false}
                    hideChannel={false}
                    policyData={policyData}
                    isDirectSelection={isDirectSelection}
                    {...props}
                />
            </div>
        </AppModal>
    );
};

export default CommunicationMasterModal;
